import { useState } from "react";
import { Switch } from "@headlessui/react";

export default function SMSwitch(props) {
  const [enabled, setEnabled] = useState(props.status ?? false);

  return (
    <div>
      <Switch
      checked={enabled}
      onChange={() => props.onChange()}
      className={`${
        enabled ? 'bg-green-600' : 'bg-red-300'
      } relative inline-flex items-center h-6 rounded-full w-11`}
    >
      {/* <span className="sr-only">Enable notifications</span> */}
      <span
        className={`${
          enabled ? 'translate-x-6' : 'translate-x-1'
        } inline-block w-4 h-4 transform bg-white rounded-full`}
      />
    </Switch>
    </div>
  );
}
